<div class="container-fluid">
  <app-pagetitle
    title="ChatBot"
    [breadcrumbItems]="breadCrumbItems"
  ></app-pagetitle>

  <div class="d-lg-flex mb-4">
    <div class="w-100 user-chat mt-4 mt-sm-0">
      <div class="p-3 px-lg-4">
        <div class="row">
          <div class="col-md-4 col-6">
            <h5 class="font-size-15 mb-1 text-truncate">Wimera ChatBot</h5>
          </div>
        <div class="col-md-4 col-6">
          <select 
            class="form-control" 
            name="deviceName" 
            id="deviceName" 
            [(ngModel)]="selectedDeviceId">

            <option *ngFor="let val of deviceList" [value]="val.deviceName">
              {{ val.deviceName }}
            </option>

          </select>
        </div>
        </div>
      </div>

      <div class="px-lg-2">
        <div class="chat-conversation p-3">
          <perfect-scrollbar style="height: 450px">
            <ul class="list-unstyled mb-0 pr-3">
              <li
                *ngFor="let data of chatMessagesData"
                [ngClass]="{
                  right: data.align === 'right',
                  'no-background': data.typing,
                  'center-message': data.align === 'centre'
                }"
              >
                <ng-container *ngIf="data.align === 'centre'; else normalChat">
                  <div
                    class="welcome-text"
                    [ngClass]="{ animated: data.animate }"
                  >
                    {{ data.message }}
                  </div>
                </ng-container>

                <ng-template #normalChat>
                  <div class="conversation-list">
                    <div class="chat-avatar">
                       <i [class]="data.icon"></i>
                    <!-- <img src="{{data.image}}" alt=""> -->
                  </div>
                    <div class="ctext-wrap">
                      <div class="conversation-name">{{ data.name }}</div>
                      <div class="ctext-wrap-content">
                        <ng-container *ngIf="data.typing; else normalOrChart">
                          <p class="mb-0">
                            <span class="typing-dot"></span>
                            <span class="typing-dot"></span>
                            <span class="typing-dot"></span>
                          </p>
                        </ng-container>

                        <ng-template #normalOrChart>
                          <ng-container *ngIf="!data.chart; else chartBlock">
                            <p class="mb-0" [innerHTML]="data.message"></p>
                          </ng-container>
                        </ng-template>

                        <ng-template #chartBlock>
                          <div
                            class="d-flex justify-content-between align-items-center mb-2"
                          >
                            <h6
                              class="mb-0 chat-chart-title"
                              style="color: white"
                            >
                              {{ data.chart.title }}
                            </h6>
                            <div
                              class="d-flex justify-content-center align-items-center"
                            >
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-light mr-2"
                                (click)="
                                  openExportModal(exportModal, data.chart)
                                "
                              >
                                <i class="mdi mdi-download"></i>
                              </button>
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-light"
                                (click)="
                                  openExpandModal(expandModal, data.chart)
                                "
                              >
                                <i class="mdi mdi-arrow-expand"></i>
                              </button>
                            </div>
                          </div>
                          <img
                            [src]="'data:image/png;base64,' + data.chart.image"
                            class="chat-chart-img mb-2"
                            alt="Chart"
                            (load)="scrollToBottom()"
                          />
                          <p class="chat-chart-description">
                            {{ data.chart.description }}
                          </p>
                        </ng-template>
                      </div>
                      <p
                        class="chat-time mb-0"
                        *ngIf="!data.typing && !data.chart"
                      >
                        <i class="mdi mdi-clock-outline align-middle mr-1"></i>
                        {{ data.time }}
                      </p>
                    </div>
                  </div>
                </ng-template>
              </li>
            </ul>
          </perfect-scrollbar>
        </div>
      </div>

      <div class="px-lg-3">
        <div class="mb-2">
          <ng-container *ngFor="let query of defaultQueries">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary defaultbtn mr-2 mb-2"
              (click)="sendDefaultQuery(query)"
            >
              {{ query }}
            </button>
          </ng-container>
        </div>

        <div class="p-3 chat-input-section">
          <form (ngSubmit)="messageSave()" [formGroup]="formData" class="row">
            <div class="col">
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control chat-input"
                  placeholder="Enter Message..."
                  formControlName="message"
                  [ngClass]="{
                    'is-invalid': chatSubmit && form.message.errors
                  }"
                />
                <div
                  *ngIf="chatSubmit && form.message.errors"
                  class="invalid-feedback"
                >
                  <span *ngIf="form.message.errors.required"
                    >This value is required.</span
                  >
                </div>
              </div>
            </div>
            <div class="col-auto">
              <button
                type="submit"
                class="btn btn-primary sendbtn chat-send w-md waves-effect waves-light"
              >
                <span class="d-none d-sm-inline-block mr-2">Send</span>
                <i class="mdi mdi-send"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #exportModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Export Chart</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      Choose export format for <strong>{{ selectedChart?.title }}</strong
      >:
    </p>
    <div class="d-flex justify-content-end">
      <button
        type="button"
        class="btn btn-primary mr-2"
        (click)="exportChartAsPDF(selectedChart); modal.close()"
      >
        PDF
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        (click)="exportChartAsPNG(selectedChart); modal.close()"
      >
        PNG
      </button>
    </div>
  </div>
</ng-template>

<ng-template #expandModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ selectedChart?.title }}</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <img
      [src]="'data:image/png;base64,' + selectedChart?.image"
      class="img-fluid mb-3"
      alt="Large Chart"
    />
    <p>{{ selectedChart?.description }}</p>
  </div>
</ng-template>
